/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AssignIPv6 {
	NONE = "none",
	PREDEFINED = "predefined",
	ACCOUNT = "account",
}
